<template>
  <div class="finalize-order-form__component">
    <b-form v-if="!$route.query.schoolId" @submit="onSubmit" class="finalize-form">
      <div class="form-content">
        <div class="category sizing">
          <h4 class="category-title">Sizing</h4>
          <div class="finalize-form-select-row">
            <div class="row__title">
              Jacket Size
            </div>
            <b-form-select v-model="sizeSelected" class="select" :options="SIZES"></b-form-select>
          </div>
          <div
            class="error-message"
            :class="{error: validation.hasError('sizeSelected')}"
          >{{validation.firstError('sizeSelected')}}
          </div>
          <div class="finalize-form-select-row">
            <div class="row__title">
              Sleeve Length
            </div>
            <b-form-select
              v-model="sleeveLengthSelected" class="select" :options="BODY_SLEEVE_LENGTH">
            </b-form-select>
          </div>
          <div class="finalize-form-select-row">
            <div class="row__title">
              Body Length
            </div>
            <b-form-select
              v-model="bodyLengthSelected" class="select" :options="BODY_SLEEVE_LENGTH">
            </b-form-select>
          </div>
          <div class="finalize-form-radio-row">
            <div class="row__title">
              Snap Style
            </div>
            <div class="panel-wrap">
              <b-form-group class="panel" v-slot="{ snapStyle }">
                <b-form-radio-group
                  v-model="snapStyleSelected"
                  :options="SNAPSTYLE"
                  :aria-describedby="snapStyle"
                  name="radio-options"
                ></b-form-radio-group>
              </b-form-group>
              <div
                class="error-message"
                :class="{error: validation.hasError('snapStyleSelected')}"
              >{{validation.firstError('snapStyleSelected')}}
              </div>
            </div>
            <div class="row__title">Lining</div>
            <div class="finalize-form-checkbox-row">
              <div class="panel-wrap">
                <b-form-group class="panel" v-slot="{ Lining }">
                  <b-form-radio-group
                    v-model="liningSelected"
                    :options="LINING"
                    :aria-describedby="Lining"
                    name="flavour-1"
                  ></b-form-radio-group>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <div class="table-wrapper">
          <h4 class="table-title">Itemized Pricing</h4>
          <FinalizeOrderTable
              :sizeSelected="sizeSelected"
              :sleeveLengthSelected="sleeveLengthSelected"
              :bodyLengthSelected="bodyLengthSelected"
              :snapStyleSelected="snapStyleSelected"
              :liningSelected="liningSelected"
          />
          <div class="revision-notes">
            <div class="textarea-title">
              Designer Notes
            </div>
            <b-form-textarea
              id="textarea"
              v-model="textNotes"
              rows="6"
              placeholder="Enter designer notes..."
            ></b-form-textarea>

            <div
              class="error-message"
              :class="{error: validation.hasError('textNotes')}"
            >
              {{validation.firstError('textNotes')}}
            </div>
          </div>
        </div>
      </div>

      <b-alert
        v-if="!!savingProjectError"
        :show="!!savingProjectError"
        variant="danger"
        dismissible
      >
        <div>{{ savingProjectError.message }}</div>
        <div class="error-details">{{ savingProjectError.details }}</div>
      </b-alert>

      <b-alert
        v-if="!!designedJacketError"
        :show="!!designedJacketError"
        variant="danger"
        dismissible
      >
        <div>{{ designedJacketError.message }}</div>
        <div class="error-details">{{ designedJacketError.details }}</div>
      </b-alert>

      <div class="button-container">
        <div class="buy-button">
          <b-button
            v-if="!savingJacket && !$route.query.schoolId"
            :disabled="!imagesIsDone"
            type="submit"
            variant="success"
          >
            CREATE JACKET PROOF
          </b-button>

          <b-button
            v-if="savingJacket && !$route.query.schoolId"
            disabled
            type="button"
            variant="success"
          >
            <b-spinner small></b-spinner>
            CREATING JACKET PROOF...
          </b-button>

          <b-button
            v-if="$route.query.schoolId"
            :disabled="!imagesIsDone || savingJacket"
            type="submit"
            variant="success"
          >
            <b-spinner v-if="savingJacket && $route.query.schoolId" small></b-spinner>
            SAVE DESIGN
          </b-button>
        </div>
      </div>
    </b-form>
    <b-form v-if="$route.query.schoolId"
            @submit="onSubmit" class="finalize-form">
      <div v-if="designedJacketId" class="form-content">
          <div class="revision-notes design-school__revision-notes">
            <div class="textarea-title">
              Revision Notes
            </div>
            <b-form-textarea
              id="textarea"
              v-model="textNotes"
              rows="6"
              placeholder="Enter revision notes..."
            ></b-form-textarea>

            <div
              class="error-message"
              :class="{error: validation.hasError('textNotes')}"
            >
              {{validation.firstError('textNotes')}}
            </div>
          </div>
      </div>

      <b-alert
        v-if="!!savingProjectError"
        :show="!!savingProjectError"
        variant="danger"
        dismissible
      >
        <div>{{ savingProjectError.message }}</div>
        <div class="error-details">{{ savingProjectError.details }}</div>
      </b-alert>

      <b-alert
        v-if="!!designedJacketError"
        :show="!!designedJacketError"
        variant="danger"
        dismissible
      >
        <div>{{ designedJacketError.message }}</div>
        <div class="error-details">{{ designedJacketError.details }}</div>
      </b-alert>

      <div class="button-container">
        <div class="buy-button">
          <b-button
            v-if="!savingJacket && !$route.query.schoolId"
            :disabled="!imagesIsDone"
            type="submit"
            variant="success"
          >
            CREATE JACKET PROOF
          </b-button>

          <b-button
            v-if="savingJacket && !$route.query.schoolId"
            disabled
            type="button"
            variant="success"
          >
            <b-spinner small></b-spinner>
            CREATING JACKET PROOF...
          </b-button>

          <b-button
            v-if="$route.query.schoolId"
            :disabled="!imagesIsDone || savingJacket"
            type="submit"
            variant="success"
          >
            <b-spinner v-if="savingJacket && $route.query.schoolId" small></b-spinner>
            SAVE DESIGN
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import FinalizeOrderTable from '@/components/finalizeOrder/FinalizeOrderTable.vue';
import {
  // eslint-disable-next-line import/named
  SIZES, BODY_SLEEVE_LENGTH, SNAPSTYLE, LINING, SIZES_NUMBERS
} from '@/common/constants';
import SimpleVueValidator from 'simple-vue-validator';

export default {
  name: 'FinalizeOrderForm',
  mixins: [SimpleVueValidator.mixin],
  components: {
    FinalizeOrderTable
  },
  validators: {
    sizeSelected (value) {
      if (this.$route.query.schoolId) return;

      // eslint-disable-next-line consistent-return
      return SimpleVueValidator.Validator.value(value).required('Select Value');
    },
    snapStyleSelected (value) {
      if (this.$route.query.schoolId) return;

      // eslint-disable-next-line consistent-return
      return SimpleVueValidator.Validator.value(value).required('Select Value');
    },
    textNotes (value) {
      // eslint-disable-next-line consistent-return
      if (!this.designedJacketId) return;
      // eslint-disable-next-line consistent-return
      return SimpleVueValidator.Validator.value(value).required('Revision Notes are required');
    }
  },
  data () {
    return {
      sizeSelected: null,
      sleeveLengthSelected: null,
      bodyLengthSelected: null,
      snapStyleSelected: null,
      liningSelected: null,
      SIZES,
      BODY_SLEEVE_LENGTH,
      SNAPSTYLE,
      LINING,
      textNotes: '',
      savingJacket: false,
    };
  },

  props: {
    imagesIsDone: Boolean,
  },

  mounted () {
    if (this.$route.query.schoolId) {
      this.sizeSelected = SIZES_NUMBERS.M;
      this.snapStyleSelected = 'Male';
    } else {
      this.sizeSelected = this.currentValues.sizeSelected;
      this.snapStyleSelected = this.currentValues.snapStyleSelected;
    }

    this.sleeveLengthSelected = this.currentValues.sleeveLengthSelected;
    this.bodyLengthSelected = this.currentValues.bodyLengthSelected;
    this.liningSelected = this.currentValues.liningSelected;
  },
  watch: {
    textNotes () {
      this.$store.commit('finalizeOrder/setRevisionNotes', this.textNotes);
    },
    sizeSelected () {
      this.$store.commit('finalizeOrder/setSizeSelected', this.sizeSelected);
      this.$store.dispatch('finalizeOrder/calculateTotalPrice');
    },
    sleeveLengthSelected () {
      this.$store.commit('finalizeOrder/setSleeveLengthSelected', this.sleeveLengthSelected);
      this.$store.dispatch('finalizeOrder/calculateTotalPrice');
    },
    bodyLengthSelected () {
      this.$store.commit('finalizeOrder/setBodyLengthSelected', this.bodyLengthSelected);
      this.$store.dispatch('finalizeOrder/calculateTotalPrice');
    },
    snapStyleSelected () {
      this.$store.commit('finalizeOrder/setSnapStyleSelected', this.snapStyleSelected);
    },
    liningSelected () {
      this.$store.commit('finalizeOrder/setLiningSelected', this.liningSelected);
      this.$store.dispatch('finalizeOrder/calculateTotalPrice');
    },
  },
  computed: {
    designedJacketError () {
      return this.$store.getters['design/getDesignedJacketError'];
    },

    projectPatches () {
      return this.$store.getters['design/getProjectPatches'];
    },

    designedJacketId () {
      return this.$store.getters['design/getDesignedJacketId'];
    },

    errorText () {
      return this.$store.getters['design/getErrorText'];
    },

    currentValues () {
      return this.$store.getters['finalizeOrder/getCurrentValues'];
    },

    savingProjectError () {
      return this.$store.getters['errors/getSavingError'];
    },

    isProjectSaving () {
      return this.$store.getters['design/isProjectSaving'];
    },
  },
  methods: {
    onSubmit (event) {
      event.preventDefault();
      if (!this.$route.query.schoolId) {
        this.$validate().then((success) => {
          if (success) {
            this.savingJacket = true;
            this.$store.dispatch('design/saveProject', {
              orderId: this.$route.query.orderId,
              designedJacketId: this.$route.query.designedJacketId,
              userId: this.$route.query.userId
            }).then(() => {
              if (!window.location.href.includes('finalize')) {
                this.savingJacket = false;
              }
            });
          }
        });
      } else {
        this.$validate().then((success) => {
          if (success) {
            this.savingJacket = true;
            this.$store.dispatch('design/saveJacketForSchool', this.$route.query.schoolId).then(() => {
              if (!window.location.href.includes('schoolId')) {
                this.savingJacket = false;
              }
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.finalize-order-form__component {
  width: 100%;
  height: 67%;
}

.finalize-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.form-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  height: 85%;
}

.design-school__revision-notes {
  width: 100%;
}

.sizing {
  margin-left: 40px;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  width: 24%;
}

.category-title {
  font-size: 20px;
  line-height: 1;
}

.finalize-form-select-row {
  width: 100%;
}

.row__title {
  margin: 20px 0px 3px 0px;
  line-height: 1;
}

.select {
  width: 100%;
}

.finalize-form-radio-row {
}

.panel {
  background-color: #f6f6f6;
  margin-bottom: 0;
  box-shadow: none;
  border: 1px solid #ccc;
  padding: 15px;
}

.table-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  height: 100%;
}

.table-title {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 15px;
}

.revision-notes {
  margin-top: 20px;
}

.textarea-title {
  font-size: 14px;
}

.numbered-bullets-log {
  margin-left: 15px;
  margin-top: 20px;
  padding: 0;
}

.bullet {
  font-size: 14px;
}

.buttons-container {
  display: flex;
}

.buy-button {
  display: flex;
  justify-content: center;
  margin-right: 20px;
  flex: 1;
}

.save-button {
  display: flex;
  justify-content: flex-end;
  width: 50%;
}

.error-message {
  display: none;
}

.error {
  display: block;
  color: red;
}

.error-details {
  white-space: pre-line
}

</style>
